import * as Types from '../graphql.generated';

import { Internal_Link_FragmentFragment } from './internalLink.fragment.generated';
import { Internal_Link_FragmentFragmentDoc } from './internalLink.fragment.generated';
export type Internal_Links_FragmentFragment = {
    __typename?: 'InternalLinks';
} & Pick<
    Types.InternalLinks,
    'category' | 'geo' | 'propertyType' | 'section' | 'transactionType'
> & {
        rows?: Types.Maybe<
            Array<
                { __typename?: 'InternalLinksRow' } & {
                    links: Array<
                        {
                            __typename?: 'InternalLink';
                        } & Internal_Link_FragmentFragment
                    >;
                }
            >
        >;
        links?: Types.Maybe<
            Array<
                { __typename?: 'InternalLink' } & Internal_Link_FragmentFragment
            >
        >;
    };

export const Internal_Links_FragmentFragmentDoc = `
    fragment INTERNAL_LINKS_FRAGMENT on InternalLinks {
  category
  geo
  propertyType
  section
  transactionType
  rows {
    links {
      ...INTERNAL_LINK_FRAGMENT
    }
  }
  links {
    ...INTERNAL_LINK_FRAGMENT
  }
}
    ${Internal_Link_FragmentFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
